import {
  QRCodeActivityType,
  QRActivityReport,
  QRActivityReportListParam,
  QRActivityReportPaginateList,
} from './activity-tracking-types';
import {
  QRCodeActivityTypeApiPayload,
  QRActivityReportApiResponse,
  QRActivityReportApiPaginateList,
  QRActivityReportApiParams,
} from './activity-tracking-api-types';

export const toActivityTypeApiPayload = (data: Partial<QRCodeActivityType>): QRCodeActivityTypeApiPayload => ({
  name: data.name ?? '',
  description: data.description,
  categoryId: typeof data.category === 'string' ? data.category : data.category?._id ?? '',
  framework: data.framework ?? '',
  enableLocationName: data.enableLocationName ?? false,
  enableNote: data.enableNote ?? false,
  status: (data.status as QRCodeActivityTypeApiPayload['status']) ?? 'Active',
});

// ─── QR Activity Report ───────────────────────────────────────────────────────

export const transformQRActivityReport = (raw: QRActivityReportApiResponse): QRActivityReport => ({
  activityName: raw.activityName,
  activityType: raw.activityType,
  category: raw.activityCategory,
  framework: raw.framework,
  activityCreatedDate: raw.activityCreatedDate ?? '',
  activityStartDate: raw.activityStartDate,
  activityEndDate: raw.activityEndDate,
  hostAgentCode: raw.hostAgentCode,
  hostOfficeCode: raw.hostOfficeCode,
  attendanceAgentCode: raw.attendanceAgentCode,
  checkInAt: raw.checkInAt,
});

export const transformQRActivityReportList = (raw: QRActivityReportApiPaginateList): QRActivityReportPaginateList => ({
  items: raw.items.map(transformQRActivityReport),
  totalRecords: raw.totalRecords,
  totalPages: raw.totalPages,
});

export const toQRActivityReportApiParams = (params: QRActivityReportListParam): QRActivityReportApiParams => ({
  availableFrom: params.availableFrom
    ? params.availableFrom instanceof Date
      ? params.availableFrom.toISOString()
      : params.availableFrom
    : null,
  availableTo: params.availableTo
    ? params.availableTo instanceof Date
      ? params.availableTo.toISOString()
      : params.availableTo
    : null,
  attendanceAgentCode: params.attendanceAgentCode || undefined,
  hostAgentCode: params.hostAgentCode || undefined,
  activityName: params.activityName || undefined,
  activityType: params.activityType || undefined,
  activityCategory: params.category || undefined,
  framework: params.framework || undefined,
  officeCode: params.officeCode || undefined,
  sortBy: params.sortBy,
  page: params.page,
  limit: params.limit,
});
